var Handlebars = require("../../../node_modules/.pnpm/handlebars@4.7.9_patch_hash=53ad8d748fa2ca3a7a0502c46f2ed1236eef8162efec84c06849dc83ad9e28e9/node_modules/handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var alias1=container.strict, alias2=container.lambda, alias3=container.escapeExpression;

  return "<p class=\"contributor-count\">\n    "
    + alias3(alias2(alias1(depth0, "contributor_count", {"start":{"line":2,"column":6},"end":{"line":2,"column":23}} ), depth0))
    + " total contributors\n    ("
    + alias3(alias2(alias1(depth0, "hundred_plus_contributor_count", {"start":{"line":3,"column":7},"end":{"line":3,"column":37}} ), depth0))
    + " with 100+ commits;\n    "
    + alias3(alias2(alias1(depth0, "twenty_plus_contributor_count", {"start":{"line":4,"column":6},"end":{"line":4,"column":35}} ), depth0))
    + " with 20+ commits)\n</p>\n";
},"useData":true});